import { Component } from "components/common";

/**
 * Eine Klasse zur Erstellung von HTML `<time>` Elementen.
 *
 * @example
 * Das folgende Beispiel erstellt ein HTML `<time>` Element.
 *
 * Erstelle ein neues HTML `<time>` Element.
 *
 * ```typescript
 * import { Time } from "components/common/time";
 *
 * const time = new Time();
 * ```
 *
 * Konfiguriere das HTML `<time>` Element durch Method Chaining.
 *
 * ```typescript
 * time
 *     .withID("time")
 *     .withClass("time");
 * ```
 *
 * Rendere nun das HTML `<time>` Element in das DOM.
 *
 * ```typescript
 * document.getElementById("root")
 *     ?.replaceChildren(time.render());
 * ```
 *
 * @public
 */
class Time extends Component<HTMLTimeElement> {
  /**
   * Erstellt ein neues HTML `<time>` Element.
   */
  constructor() {
    super(document.createElement("time"));
  }

  /**
   * Fügt eine Zeitangabe hinzu.
   *
   * @param dateTime - Eine Zeitangabe in einem gültigen Format und in
   *                   maschinenlesbarer Form.
   * @returns Das HTML `<time>` Element mit der maschinenlesbaren Zeitangabe.
   *
   * @public
   */
  public withDateTime(dateTime: HTMLTimeElement["dateTime"]) {
    this.element.dateTime = dateTime;

    return this;
  }
}

export { Time };
